import api from "./api";
import auth from "./auth";

export default {
    getList(page, filter) {
        return new Promise((resolve, reject) => {
            api.post(
                "feedback-service/cms/feedback/list/" + page,
                filter,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getFeedbackInfo(uuid) {
        return new Promise((resolve, reject) => {
            api.post(
                "feedback-service/cms/feedback/info",
                { uuid: uuid },
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    sendReply(fields) {
        return new Promise((resolve, reject) => {
            api.post(
                "feedback-service/cms/feedback/response",
                fields,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    export(filter) {
        return new Promise((resolve, reject) => {
            api.post(
                "feedback-service/cms/feedback/export",
                filter,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    }
};
